import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 5FCBB812-F381-4E83-B60E-E126992910FB
 * name silverware-spoon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/silverware-spoon.svg
 * tags
 * - Food / Drink 
 */
export const SilverwareSpoonIcon = createSvgIcon(<><path d="M14.88,11.53L5.12,21.29L3.71,19.88L13.47,10.12C12.76,8.59 13.26,6.44 14.85,4.85C16.76,2.93 19.5,2.57 20.96,4.03C22.43,5.5 22.07,8.24 20.15,10.15C18.56,11.74 16.41,12.24 14.88,11.53Z" /></>, 'SilverwareSpoonIcon');
export default SilverwareSpoonIcon